/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { ChangePasswordOptions, ChangePasswordResponses } from '../../models/ChangePassword'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Change Password
 * {@link /auth/change-password}
 */
export function changePassword<ThrowOnError extends boolean = true>(options: Options<ChangePasswordOptions, ThrowOnError>): Promise<UnwrappedResult<ChangePasswordResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/auth/change-password', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<ChangePasswordResponses, ThrowOnError>>
}
